import { ActionReducerMap } from '@ngrx/store';
import * as fromOrderForm from './order.form.reducer';
import * as fromDirectDebitValidation from './direct.debit.validation.reducer';
import * as fromDirectDebitAutofill from './direct.debit.autofill.reducer';
import * as fromDirectDebitAttempts from './direct.debit.attempts.reducer';
import * as fromStepper from './stepper.reducer';
import * as fromCreateOrder from './create.order.reducer';
import * as fromCardPaymentRedirect from './card.payment.redirect.reducer';
import * as fromWorldPay from './worldpay.reducer';
import * as fromUpfrontPayment from './upfront.payment.reducer';

export interface CompleteOrderState {
  readonly upfrontPayment: fromUpfrontPayment.UpfrontPaymentState;
  readonly orderForm: fromOrderForm.OrderFormState;
  readonly directDebitValidation: fromDirectDebitValidation.DirectDebitValidationState;
  readonly directDebitAutofill: fromDirectDebitAutofill.DirectDebitAutofillState;
  readonly directDebitAttempts: fromDirectDebitAttempts.DirectDebitAttemptsState;
  readonly activeFormStep: fromStepper.StepperState;
  readonly createOrder: fromCreateOrder.CreateOrderState;
  readonly cardPaymentRedirect: fromCardPaymentRedirect.CardPaymentRedirectState;
  readonly worldPay: fromWorldPay.WorldPayState;
}

export const completeOrderReducers: ActionReducerMap<CompleteOrderState> = {
  upfrontPayment: fromUpfrontPayment.reducer,
  orderForm: fromOrderForm.reducer,
  directDebitValidation: fromDirectDebitValidation.reducer,
  directDebitAutofill: fromDirectDebitAutofill.reducer,
  directDebitAttempts: fromDirectDebitAttempts.reducer,
  activeFormStep: fromStepper.reducer,
  createOrder: fromCreateOrder.reducer,
  cardPaymentRedirect: fromCardPaymentRedirect.reducer,
  worldPay: fromWorldPay.reducer,
};

export const COMPLETE_ORDER_FEATURE = 'completeOrder';
